import * as m from "#/paraglide/messages";
import {
  createBackendFailureMessageResolver,
  readBackendFailure,
} from "#/shared/lib/backend-api";

import {
  startPlaygroundSessionOperation,
  type StartPlaygroundSessionOperation,
} from "../api/start-playground-session";

const resolveFailureMessage =
  createBackendFailureMessageResolver<StartPlaygroundSessionOperation>({
    forbidden: () => m.playground_failure_forbidden(),
    network: () => m.playground_failure_network(),
    rejected: () => m.playground_failure_rejected(),
    schema: () => m.playground_failure_schema(),
    unexpected: () => m.playground_failure_unexpected(),
  });

/** 开会话失败时的文案；不是本 feature 的失败返回 null。 */
export function readPlaygroundFailureMessage(error: unknown): string | null {
  return resolveFailureMessage(
    readBackendFailure(error, [startPlaygroundSessionOperation]),
  );
}
